export default async (args = {}) => {
  return `Você pode falar conosco pelo telefone <strong>${site.fone}</strong>.`
}